import axios from 'axios';
import { store } from './store';
import { setAccessToken, setLogout, setSubscriptionStatus } from './state';

const PRESENTATION_MODE =
  process.env.REACT_APP_PRESENTATION_MODE === "true";

let api;



if (PRESENTATION_MODE) {
  api = {
    get: async () => Promise.resolve({ data: null }),
    post: async () => Promise.resolve({ data: null }),
    put: async () => Promise.resolve({ data: null }),
    delete: async () => Promise.resolve({ data: null }),
  };
}

else {
  api = axios.create({
    baseURL: process.env.REACT_APP_API_BASE,
    withCredentials: true,
  });

  let refreshPromise = null; // Prevent multiple refresh calls at the same time


  const refreshAccessToken = async () => {
    if (!refreshPromise) {
      refreshPromise = api.post('/auth/refresh')
        .then((res) => {
          const { accessToken, expiresAt } = res.data;
          store.dispatch(setAccessToken({ token: accessToken, expiresAt: expiresAt }));
          return { accessToken, expiresAt };
        })
        .catch(async (err) => {
          if (err.response?.status === 401 || err.response?.status === 403) {
            store.dispatch(setLogout());
          }
          // throw err;
        })
        .finally(() => {
          refreshPromise = null;
        });
    }
    return refreshPromise;
  };

  // Request interceptor → attach token
  api.interceptors.request.use(
    (config) => {
      const token = store.getState().token;
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  // Response interceptor → handle 401 errors
  api.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;

      const isAuthRoute = originalRequest.url?.includes('/auth/refresh') ||
        originalRequest.url?.includes('/auth/logout');

      // skip interceptor for auth routes
      if (isAuthRoute) {
        if (error.response?.status === 401 || error.response?.status === 403) {
          store.dispatch(setLogout());
        }
        return Promise.reject(error);
      }

      // if (error.response?.status === 401 && !originalRequest._retry) {

      //   if (error.response.data?.error === 'USER_NOT_FOUND') {
      //     // await api.post("/auth/logout").catch(() => {});
      //     store.dispatch(setLogout());
      //     return Promise.reject(error);
      //   }
      //   originalRequest._retry = true;

      //   try {
      //     const { accessToken } = await refreshAccessToken();
      //     originalRequest.headers['Authorization'] = `Bearer ${accessToken}`;
      //     return api(originalRequest);
      //   } catch (refreshError) {
      //     return Promise.reject(refreshError);
      //   }
      // }
      if (error.response?.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;

        try {
          const result = await refreshAccessToken();
          if (!result || !result?.accessToken) return
          originalRequest.headers['Authorization'] = `Bearer ${result.accessToken}`;
          return api(originalRequest);
        } catch (refreshError) {
          // already logged out in refreshAccessToken, just silently reject
          return Promise.reject(refreshError);
        }
      }

      if (error.response?.status === 403) {
        // Subscription-related error
        if (error.response.data?.error === 'SUBSCRIPTION_REQUIRED') {
          store.dispatch(setSubscriptionStatus({ subscriptionStatus: error.response.data?.status }));
        }
      }

      return Promise.reject(error);
    }
  );
}


window.addEventListener('unhandledrejection', (event) => {
  // console.error('Unhandled rejection at:', event.reason);
  event.preventDefault(); // suppresses the console warning
});

export default api;
